import { Amplify } from 'aws-amplify';

// Amplify configuration for Cognito authentication
const amplifyConfig = {
  Auth: {
    Cognito: {
      // User Pool configuration - with production fallback values
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-northeast-1_yJCEVpW0N',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '6q5ln14653g4196ffi7jop1cel',
      
      // Identity Pool configuration - with production fallback values
      identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || 'ap-northeast-1:274e9a26-1063-4d8f-a229-9b7c25eb0589',
      
      // Hosted UI configuration
      loginWith: {
        oauth: {
          domain: `${import.meta.env.VITE_COGNITO_DOMAIN || 'enterprise-auth-dev-auth'}.auth.${import.meta.env.VITE_AWS_REGION || 'ap-northeast-1'}.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [
            import.meta.env.VITE_REDIRECT_SIGN_IN || `${window.location.origin}`,
          ],
          redirectSignOut: [
            import.meta.env.VITE_REDIRECT_SIGN_OUT || `${window.location.origin}`,
          ],
          responseType: 'code' as const,
          // Cognitoが自動的に利用可能なプロバイダーを表示するため、providers指定は不要
          // providers: [], 
        },
      },
      
      // Password policy (for reference, actual policy is set in Cognito)
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  
  // Storage configuration for S3 access
  Storage: {
    S3: {
      bucket: import.meta.env.VITE_S3_BUCKET || '',
      region: import.meta.env.VITE_AWS_REGION || 'ap-northeast-1',
    },
  },
  
  // API configuration (for future API Gateway integration)
  API: {
    REST: {
      'enterprise-auth-api': {
        endpoint: import.meta.env.VITE_API_BASE_URL || 'https://xacarwhmll.execute-api.ap-northeast-1.amazonaws.com/dev',
        region: import.meta.env.VITE_AWS_REGION || 'ap-northeast-1',
      },
    },
  },
};

// Configure Amplify
Amplify.configure(amplifyConfig);

export default amplifyConfig;

// Helper function to get current configuration
export const getAmplifyConfig = () => amplifyConfig;

// Helper function to check if Amplify is properly configured
export const isAmplifyConfigured = (): boolean => {
  const config = amplifyConfig.Auth.Cognito;
  return !!(
    config.userPoolId &&
    config.userPoolClientId &&
    config.identityPoolId
  );
};

// Helper function to get OAuth URLs
export const getOAuthUrls = () => {
  const domain = amplifyConfig.Auth.Cognito.loginWith.oauth.domain;
  const region = import.meta.env.VITE_AWS_REGION || 'ap-northeast-1';
  const clientId = amplifyConfig.Auth.Cognito.userPoolClientId;
  const redirectUri = encodeURIComponent(`${window.location.origin}/auth/callback`);
  const logoutUri = encodeURIComponent(`${window.location.origin}/auth/logout`);
  
  return {
    login: `https://${domain}.auth.${region}.amazoncognito.com/login?client_id=${clientId}&response_type=code&scope=email+openid+profile&redirect_uri=${redirectUri}`,
    logout: `https://${domain}.auth.${region}.amazoncognito.com/logout?client_id=${clientId}&logout_uri=${logoutUri}`,
    signup: `https://${domain}.auth.${region}.amazoncognito.com/signup?client_id=${clientId}&response_type=code&scope=email+openid+profile&redirect_uri=${redirectUri}`,
  };
};

// Environment validation
export const validateEnvironment = () => {
  const requiredEnvVars = [
    'VITE_COGNITO_USER_POOL_ID',
    'VITE_COGNITO_CLIENT_ID',
    'VITE_COGNITO_IDENTITY_POOL_ID',
    'VITE_COGNITO_DOMAIN',
    'VITE_AWS_REGION',
  ];

  const missingVars = requiredEnvVars.filter(
    (varName) => !import.meta.env[varName]
  );

  if (missingVars.length > 0) {
    console.warn(
      'Missing required environment variables:',
      missingVars.join(', ')
    );
    console.warn(
      'Please check your .env file and ensure all Cognito configuration variables are set.'
    );
  }

  return missingVars.length === 0;
};

// Development helper to log configuration (only in debug mode)
if (import.meta.env.DEV && import.meta.env.VITE_DEBUG_MODE === 'true') {
  console.log('Amplify Configuration:', {
    userPoolId: amplifyConfig.Auth.Cognito.userPoolId,
    clientId: amplifyConfig.Auth.Cognito.userPoolClientId,
    domain: amplifyConfig.Auth.Cognito.loginWith.oauth.domain,
    environment: import.meta.env.VITE_ENVIRONMENT,
    isConfigured: isAmplifyConfigured(),
    environmentValid: validateEnvironment(),
  });
}
